import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod } from "theme";

var _KlaviyoBis_instances, form_get, onSubmit_fn;
var KlaviyoBis = class extends HTMLElement {
  constructor() {
	  super();
	  __privateAdd(this, _KlaviyoBis_instances);
	  this.addEventListener("submit", __privateMethod(this, _KlaviyoBis_instances, onSubmit_fn));
  }
  connectedCallback() {
  }
  
  get klaviyoId() {
	  return this.getAttribute("klaviyo-id");
  }
  
  get variantId() {
	  return this.getAttribute("variant-id");
  }
  
};

_KlaviyoBis_instances = new WeakSet();

form_get = function() {
  return this.querySelector("form");
};

onSubmit_fn = async function(event) {
	event.preventDefault();
	if (!__privateGet(this, _KlaviyoBis_instances, form_get).checkValidity()) {
		__privateGet(this, _KlaviyoBis_instances, form_get).reportValidity();
		return;
	}
	const emailAddress = this.querySelector('input[type="email"]').value;
	
	const submitButtons = Array.from(__privateGet(this, _KlaviyoBis_instances, form_get).elements).filter((button) => button.type === "submit");
	submitButtons.forEach((submitButton) => {
		submitButton.setAttribute("disabled", "disabled");
		submitButton.setAttribute("aria-busy", "true");
	});
	
	document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  
	const body_data = {
		"data": {
			"type": "back-in-stock-subscription",
			"attributes": {
				"channels": [
					"EMAIL"
				],
				"profile": {
					"data": {
						"type": "profile",
						"attributes": {
							"email": emailAddress
						}
					}
				}
			},
			"relationships": {
				"variant": {
					"data": {
						"type": "catalog-variant",
						"id": "$shopify:::$default:::" + this.variantId
					}
				}
			}
		}
	};

	const options = {
		method: 'POST',
		headers: {
			accept: 'application/vnd.api+json',
			revision: '2025-01-15',
			'content-type': 'application/vnd.api+json'
		},
		body: JSON.stringify(body_data)
	};
	
	const fetchUrl = 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + this.klaviyoId;
    const response = await fetch(fetchUrl, options);
  
	submitButtons.forEach((submitButton) => {
		submitButton.removeAttribute("disabled");
		submitButton.removeAttribute("aria-busy");
	});
	
	document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
	
	if (response.ok) {
		console.log('ok');
	} else {
		console.log('not ok');
	}
};

if (!window.customElements.get("klaviyo-bis-ghd")) {
  window.customElements.define("klaviyo-bis-ghd", KlaviyoBis);
}